import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLogin: false, // 登录状态
    userId: ''      // 存储用户ID
  },
  mutations: {
    // 登录成功：更新状态
    LOGIN_SUCCESS(state, userId) {
      state.isLogin = true;
      state.userId = userId; // 确保 userId 为后端返回的有效值
    },
    // 退出登录：单独处理，重置所有状态
    LOGOUT(state) {
      state.isLogin = false;
      state.userId = ''; // 重置为初始空字符串
      localStorage.removeItem('userId'); // 同步清理本地缓存
    }
  },
  actions: {
    // 登录 action：触发登录成功的 mutation
    login({ commit }, userId) {
      commit('LOGIN_SUCCESS', userId);
    },
    // 退出登录 action：触发退出的 mutation
    logout({ commit }) {
      commit('LOGOUT');
    }
  },
  getters: {
    // 判断是否已登录：同时校验状态和 userId 有效性
    isAuthenticated: (state) => state.isLogin && !!state.userId
  }
});